
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import FaqSection from "@/components/FaqSection.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd } from "@/utils/seo";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb,
    FaqSection
  }
})
export default class Ivy extends Vue {
  // FAQ 数据（与 seo.ts 中 FAQ JSON-LD 对应）
  faqList = [
    { question: "常青藤项目面向什么人群？", answer: "面向企业接班人与新商业领袖，聚焦企业传承与创新发展。" },
    { question: "常青藤项目有哪些特色？", answer: "聚焦企业传承、第二增长曲线、传统转型、代际对话，提供专属活动与国际视野。" }
  ];
  get metaInfo() {
    return generateMetaInfo({
      title: "常青藤 | 企业接班人·新商业领袖培养计划 - 光华赋能",
      description:
        "光华共创会常青藤项目，面向企业接班人与新商业领袖，聚焦企业传承、第二增长曲线、传统转型、代际对话，提供专属活动与国际视野，助力企业永续发展。",
      keywords:
        "常青藤,企业接班人,新商业领袖,企业传承,第二增长曲线,传统转型,代际对话,光华赋能",
      path: "/ivy",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "共创会" },
        { name: "常青藤" }
      ],
      jsonLd: getServiceJsonLd({
        name: "常青藤",
        description:
          "面向企业接班人与新商业领袖的培养计划，聚焦企业传承、第二增长曲线与代际对话。",
        category: "企业接班人培养"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  List = [
    { title: "共创会", url: "" },
    { title: "常青藤", url: "" }
  ];

  pic1 = "/img/41e549229c6360cc4296d2735f1e405d.png";
  pic3 = "/img/e5d3d67f84827377552a3716b1efab5e.png";

  ivy1 = "/img/29f83a8e40d56e6495b1398a033d41a6.png";
  ivy2 = "/img/411eaef66408c3afbfe6a3ce274ac79b.png";
  ivy3 = "/img/8ee682135d5978b13afcb7b6c0634a6f.png";
  ivy4 = "/img/9dac0e78decd2fac2cb165d585e2a86a.png";
  ivy5 = "/img/abe0f25b44dc046883c677ba035ebdb7.png";
  ivy6 = "/img/a0d118adfee057471daec923cd6ddee7.png";
  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "共创会，大思维书院，实战EMBA，EMBA，常青藤"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业老板，专业的老板,实战EMBA,总裁班,学东西，交朋友，整资源，提升业务，企业负责人,联合创始人,企业接班人,大思维书院说明：标杆企业家,终身说明，前沿趋势，提升思维，思维层次，终身学习，大思维，科学经营底座，高质量发展常青藤说明：新生代企业家，传承接力，破局求变，转型升级，户外拓展，企业家私董会，共创会EMBA校友日，校友日，共创会年度高峰论坛，高峰论坛，论坛，精品研学，同学小聚"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
